import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGT = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M50 25c0-9.911-5.768-18.475-14.13-22.519v45.038C44.232 43.476 50 34.912 50 25ZM0 25c0 9.912 5.768 18.476 14.13 22.52V2.48C5.768 6.525 0 15.089 0 25.001Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#ACABB1",
  d: "M31.533 29.228 27.306 25l4.023-4.024-.182-2.125-1.152-1.153L25 22.695l-4.995-4.996-1.152 1.152-.183 2.126L22.694 25l-4.227 4.227 2.306 2.305L25 27.306l4.227 4.227 2.306-2.305Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "m31.149 18.851-2.306 2.306a5.435 5.435 0 1 1-7.686 0l-2.306-2.306A8.695 8.695 0 1 0 33.695 25a8.668 8.668 0 0 0-2.546-6.149Z"
}));
FlagGT.displayName = 'FlagGT';
export default withFlagWrapper(FlagGT);
//# sourceMappingURL=index.js.map